// Константы сроков тарифов
export const TariffTime = {
    // 1 месяц
    ONE_MONTH: 'month_1',
    ONE_MONTH_ID: 0,
    // 3 месяца
    THREE_MONTHS: 'month_3',
    THREE_MONTHS_ID: 1,
    // 6 месяцев
    HALF_YEAR: 'month_6',
    HALF_YEAR_ID: 2,
    // 12 месяцев
    ONE_YEAR: 'month_12',
    ONE_YEAR_ID: 3,
}

export const TariffDaysMap = {
    0: 31,
    1: 92,
    2: 184,
    3: 366
}
